import React, { useEffect, useState } from 'react';
import { Image, Text, View } from '@applane/react-core-components';
import { changePassword } from '../../AppServices';
import { closeIcon, eyeCloseIcon, eyeOpenIcon } from '../../images';

const theme = {
  boxToHoldEverything: {
    // border: '1px solid red',
    width: 350,
    height: 500,
    margin: 'auto',
    borderRadius: 5,
    padding: '10px 0px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 20,
    backgroundColor: 'white',
  },

  boxToHoldForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    padding: '20px 0px',
    marginBottom: 50,
  },

  boxToHoldLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  labelBox: {
    width: 300,
    fontSize: '16px',
  },

  flexBoxToHoldFieldAndIcon: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 35,
    marginBottom: 20,
  },

  boxToHoldField: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 'inherit',
    // width: 370,
  },

  boxToHoldEye: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 'inherit',
    borderTop: '1px solid grey',
    borderRight: '1px solid grey',
    borderBottom: '1px solid grey',
    borderLeft: '0px',
  },

  eyeProperties: {
    width: 15,
    height: 15,
  },

  fieldProperties: {
    borderTop: '1px solid grey',
    borderRight: '0px',
    borderBottom: '1px solid grey',
    borderLeft: '1px solid grey',
    width: 'inherit',
    height: 'inherit',
    paddingLeft: 5,
    outline: '0px',
    fontSize: 18,
  },
};

export const PasswordScreen = (props) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [pe, setPE] = useState(false);
  const [ce, setCE] = useState(false);
  const { navigation } = props;
  console.log('navigation-->', navigation);
  const type = navigation?.state?.params?.type;
  const handleSubmit = () => {
    if (!password || !confirm) {
      setMessage(`All the fields are required`);
    }

    if (password && confirm) {
      if (password !== confirm) {
        setMessage(`Password and confirm password do not match.`);
      } else {
        const validate =
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,16}$/.test(
            password,
          );

        if (!validate) {
          if (password.length < 6) {
            setMessage('Password must have minimum 6 characters.');
          } else if (password.length > 16) {
            setMessage('Password should not exceed 16 characters.');
          } else {
            setMessage(
              `Password should contain at least one letter, one number and one special character.`,
            );
          }
        } else {
          let toPass = {
            newPassword: password,
            confirmPassword: confirm,
          };
          if (type === 'superadmin') {
            toPass.user = { username: 'superadmin' };
          } else {
            toPass[type] = { _id: navigation?.state?.params?.item?._id };
          }

          changePassword(toPass).then(() => {
            navigation.pop();
          });
        }
      }
    }
  };

  return (
    <>
      <div style={theme.boxToHoldEverything}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row-reverse',
            alignItems: 'center',
            width: '95%',
          }}>
          <Image
            source={closeIcon}
            style={{ cursor: 'pointer', marginTop: 4 }}
            onClick={() => {
              navigation.pop();
            }}
          />
        </div>

        <div style={theme.boxToHoldForm}>
          <form>
            <label style={theme.boxToHoldLabel}>
              <div style={theme.labelBox}>Password</div>
            </label>
            <div style={theme.flexBoxToHoldFieldAndIcon}>
              <div style={theme.boxToHoldField}>
                <input
                  style={theme.fieldProperties}
                  type={pe ? 'text' : 'password'}
                  value={password}
                  placeholder="Enter new password"
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
              </div>
              <div style={theme.boxToHoldEye}>
                <Image
                  style={theme.eyeProperties}
                  source={pe ? eyeOpenIcon : eyeCloseIcon}
                  onClick={() => {
                    setPE(!pe);
                  }}
                />
              </div>
            </div>

            <label style={theme.boxToHoldLabel}>
              <div style={theme.labelBox}>Confirm Password</div>
            </label>
            <div style={theme.flexBoxToHoldFieldAndIcon}>
              <div style={theme.boxToHoldField}>
                <input
                  style={theme.fieldProperties}
                  type={ce ? 'text' : 'password'}
                  value={confirm}
                  placeholder="Re-enter password"
                  onChange={(e) => {
                    setConfirm(e.target.value);
                  }}
                />
              </div>
              <div style={theme.boxToHoldEye}>
                <Image
                  source={ce ? eyeOpenIcon : eyeCloseIcon}
                  style={theme.eyeProperties}
                  onClick={() => {
                    setCE(!ce);
                  }}
                />
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                marginTop: 10,
              }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  width: 400,
                  marginTop: 30,
                }}>
                <input
                  onClick={handleSubmit}
                  type="button"
                  value="Save"
                  style={{
                    width: 100,
                    height: 35,
                    backgroundColor: 'black',
                    color: 'white',
                    fontSize: '18px',
                    borderRadius: 20,
                  }}
                />
              </div>
            </div>
          </form>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '20px 0px',
            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '90%',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <i style={{ color: 'red', fontSize: 20, textAlign: 'center' }}>
                {message}
              </i>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '10px 0px',
            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '90%',
                padding: '15px 0px',
                fontSize: 20,
                textAlign: 'center',
              }}>
              Password must have 6-16 characters. It should contain at least one
              letter, one number and one special character.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
